import { Option } from "@hilma/forms";
import { UserStatus } from "../types";

export const candidateStatus: Option[] = [
    { id: UserStatus.Approved, value: 'בקשה מאושרת' },
    { id: UserStatus.Pending, value: 'בקשה בבדיקה' },
    { id: UserStatus.Denied, value: 'לא זמין לבקשה' }
];